/**
 * A country or region code → its English name, the ONE owner of that lookup
 * (P-14). GeoIP stores ISO 3166-1 alpha-2 codes (`US`), and a chart axis or a
 * table cell reads better as "United States".
 *
 * `Intl.DisplayNames` is built once and reused: constructing one per cell
 * would allocate a formatter for every row of every table. English, because
 * the product copy is English and the GeoIP names (`country_name`) are too.
 *
 * Anything that is not a two-letter code, or a code the runtime cannot name
 * (it answers "Unknown Region" or echoes the code), comes back unchanged: a
 * raw code is better than a wrong name or a blank.
 */
let displayNames: Intl.DisplayNames | undefined

const ALPHA_2 = /^[a-z]{2}$/i

export const regionName = (code: string): string => {
	if (!ALPHA_2.test(code)) return code
	displayNames ??= new Intl.DisplayNames(['en'], {
		type: 'region',
		fallback: 'code',
	})
	try {
		const name = displayNames.of(code.toUpperCase())
		return name && name !== code.toUpperCase() && name !== 'Unknown Region'
			? name
			: code
	} catch {
		return code
	}
}
